export enum SIDEBAR_NAV_ITEM_STATE {
  DEFAULT = 'default',
  ACTIVE = 'active',
}
export enum SIDEBAR_NAV_ITEM_LAYOUT {
  MENU = 'menu',
  FLYOUT = 'flyout',
  SHEET = 'sheet',
}
